import { DateTime } from 'luxon';
import React, { useContext } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SDatePicker from 'components/SDatePicker';

import { makeStyles } from 'tss-react/mui';
import { FrequencyContext } from './state';

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  freqDescription: {
    paddingBottom: 8,
    fontSize: 12,
  },
  datePicker: {
    width: 'max-content !important',
  },
}));

type OneTimeProps = {
  onDateChange: (date: DateTime) => void;
};

const OneTime = ({ onDateChange }: OneTimeProps) => {
  const { state, dispatch } = useContext(FrequencyContext);
  const { classes } = useStyles();

  const handleDateChange = (date: DateTime) => {
    const updatedDate = date?.isValid ? date : DateTime.local();
    onDateChange(date);
    dispatch({ type: 'UPDATE_ONE_TIME', payload: updatedDate });
  };

  return (
    <Box id='one-time-date-picker' className={classes.root}>
      <Typography className={classes.freqDescription}>
        Pick a date. This will also be your next payment date.
      </Typography>
      <SDatePicker
        // @ts-expect-error FIXME TS2322
        id='one-time'
        className={classes.datePicker}
        value={state.dueOn}
        onChange={handleDateChange}
        minDate={DateTime.local()}
        label={'Due date'}
        error={!state.dueOn?.isValid}
        helperText={state.dueOn?.isValid ? '' : 'Required'}
      />
    </Box>
  );
};

export default OneTime;
